import { type ServerResponse, axios } from '../axios'

export interface Notification {
  id: number
  user: number
  username: string
  createdAt: string
  createdBy: string
  code: 'indicatorSuggestedChange' | 'surveyStoplightNoteAdded'
  message: string[]
  read: boolean
}

export interface NotificationsByUser {
  content: Notification[]
  page: number
  totalElements: number
  totalPages: number
}

/**
 * Get all the notifications for the current user
 * @param params
 */
export async function getAllNotificationsByUser(
  params = {
    page: 0,
    size: 25,
    showAll: true,
  },
) {
  const response = await axios<
    ServerResponse<{ listAllNotificationsByUserPaginated: NotificationsByUser }>
  >({
    method: 'post',
    url: '/graphql',
    data: JSON.stringify({
      query:
        'query listAllNotificationsByUserPaginated ($page: Int, $size: Int, $showAll: Boolean) { listAllNotificationsByUserPaginated (page: $page, size: $size, showAll: $showAll) { content {id user username createdAt createdBy code message read } page totalElements totalPages} }',
      variables: params,
    }),
  })

  return response.data.data.listAllNotificationsByUserPaginated
}

/**
 * Mark a list of notifications as read
 * @param notifications The list of notifications id to mark as read
 */
export async function markNotificationsAsRead(notifications: number[]) {
  return await axios({
    method: 'post',
    url: '/graphql',
    data: JSON.stringify({
      query:
        'mutation markNotificationsAsRead($notifications : [Long]) { markNotificationsAsRead(notifications:$notifications) { successful } }',
      variables: { notifications },
    }),
  })
}
